// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum OutgoingPayGatePaymentStatus {
  Unknown = "UNKNOWN",
  Exported = "EXPORTED",
  RefundOnPayGateEnqueued = "REFUND_ON_PAY_GATE_ENQUEUED",
  RefundOnPayGatePostponed = "REFUND_ON_PAY_GATE_POSTPONED",
  RefundOnPayGateAuthorized = "REFUND_ON_PAY_GATE_AUTHORIZED",
  RefundOnPayGateFailed = "REFUND_ON_PAY_GATE_FAILED",
  Settled = "SETTLED",
}
export default OutgoingPayGatePaymentStatus;
